<aside class="alert variant-filled-surface">
	<div class="alert-message">
		<p>
			This is a pretty long video. I won't blame you if you want to see <a href="#shorts"
				>Video Shorts</a
			> instead.
		</p>
	</div>
</aside>
